import { Box, CssBaseline, Grid, IconButton, Paper, Stack, Switch, Typography, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import GaugeChart from 'react-gauge-chart'
import InverterCard from '../../../../../components/inverter/InverterCard'
import { Tab, Tabs } from 'react-bootstrap'
import ControlTabContent from './controlling_tabs/ControlTabContent'
import SetValuesTabContent from './controlling_tabs/SetValuesTabContent'
import { useLocation } from 'react-router-dom'
import { InverterContext } from '../../../../../context/InverterContext'
import { getDateTimeForPvParameter } from '../../../../../utils'
import Loading from '../../../../../components/loading/Loading'
import DataNotFound from '../../../../../components/error/DataNotFound'
import OutputLog from './output_graph_tabs/OutputLog'

function ControllingGroup() {
    const { spacing, palette, shape: { borderRadius } } = useTheme()
    const { getHYBRDControls, HYBRD_CONTROLS_DATA, HYBRD_CONTROLS_LOADING, getHYBRD_Control_Log1, HYBRD_CONTROLS_LOG_DATA, HYBRD_CONTROLS_LOG_DATA_LOADING } = useContext(InverterContext)
    let TableHead = []
    const LOGIN_ID = localStorage.getItem('LoginID')
    const LOC_CODE = localStorage.getItem('LCODE')
    const [DT1, setDT1] = useState(getDateTimeForPvParameter().LastDay)
    const [DT2, setDT2] = useState(getDateTimeForPvParameter().Today)
    const location = useLocation();
    const PASS_KEY = "XXXXXXXXXXXX"
    const PASS_KEY1 = "xyz"
    const WEB_KEY1 = "WEBXYZ321"
    const WEB_KEY = "WEBXYZABC"
    const IROW = 1
    const IROW1 = 0

    // const TYP11 = "FLAG"
    const [TYP, setTYP] = useState('FLAG');

    useEffect(() => {
        getHYBRDControls(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT2, DT2)
    }, [TYP])


    function onRefreshClickHandler() {
        getHYBRDControls(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT2, DT2)
    }

    useEffect(() => {
        const intervalCall = setInterval(() => {
            getHYBRDControls(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT2, DT2)
        }, 60000);
        return () => {
            // clean up
            clearInterval(intervalCall);
        };
    }, []);

    function onRefreshLogData() {

    }
    const TYP22 = "FLAG"
    const TYP33 = "WRITE"

    useEffect(() => {
        if (TYP == "Log1") {
            getHYBRD_Control_Log1(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP22, IROW1, DT1, DT2)
        } else if (TYP == "Log2") {
            getHYBRD_Control_Log1(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP33, IROW1, DT1, DT2)
        }
    }, [TYP])



    if (HYBRD_CONTROLS_LOG_DATA && HYBRD_CONTROLS_LOG_DATA?.length > 0) {
        TableHead = Object.keys(HYBRD_CONTROLS_LOG_DATA[0])
    }

    return (
        <>
            <CssBaseline />
            <Box flex={1} bgcolor={'background.default'} py={spacing(1)}>
                <Tabs
                    style={{ justifyContent: "flex-start" }}
                    id="controlled-tab-example"
                    activeKey={TYP}
                    onSelect={(k) => setTYP(k)}
                >
                    <Tab style={{}} eventKey="FLAG" title="Control">
                        {
                            HYBRD_CONTROLS_LOADING ? <Loading /> :
                                !HYBRD_CONTROLS_DATA ? <DataNotFound /> :
                                    <ControlTabContent onRefreshClick={onRefreshClickHandler} data={HYBRD_CONTROLS_DATA} />

                        }
                    </Tab>
                    <Tab style={{}} eventKey="WRITE" title="Set Values">
                        <SetValuesTabContent />
                    </Tab>
                    <Tab eventKey="Log1" title="Log1">
                        <OutputLog
                            onRefreshData={onRefreshLogData}
                            ValueOf1={DT1}
                            ValueOf2={DT2}
                            TableHead={TableHead}
                            TableData={HYBRD_CONTROLS_LOG_DATA}
                            onChangeValueOF1={(val) => setDT1(val.target.value)}
                            onChangeValueOF2={(val) => setDT2(val.target.value)}
                        />
                    </Tab>
                    <Tab eventKey="Log2" title="Log2">
                        <OutputLog
                            onRefreshData={onRefreshLogData}
                            ValueOf1={DT1}
                            ValueOf2={DT2}
                            TableHead={TableHead}
                            TableData={HYBRD_CONTROLS_LOG_DATA}
                            onChangeValueOF1={(val) => setDT1(val.target.value)}
                            onChangeValueOF2={(val) => setDT2(val.target.value)}
                        />
                    </Tab>
                </Tabs>
            </Box>
        </>
    )
}

export default ControllingGroup
